import { ElementRef } from '@angular/core'

export abstract class FncBaseCompnent {
  constructor(public element: ElementRef) {}
}
